import { FC, useEffect, useState } from 'react';
import dayjs from 'dayjs';

import * as C from './Timer.const';
import * as T from './Timer.types';
import * as U from './Timer.utils';

import css from './Timer.module.scss';

export const Timer: FC<T.ITimer> = (props) => {
  const [timerValues, setTimerValues] = useState<T.TTimerValues>(
    C.initialTimerValues
  );

  useEffect(() => {
    const timeMark = props.utcHour
      ? dayjs().add(1, 'day').utc().hour(props.utcHour).minute(0).second(0)
      : dayjs().utcOffset(C.MOSCOW_UTC_OFFSET).endOf('day');

    const setTimer = () => {
      const res = U.calculateTimerValues(timeMark.toISOString());

      setTimerValues({ ...res });

      // если время истекло
      if (JSON.stringify(res) === JSON.stringify(C.initialTimerValues)) {
        clearInterval(intervalId);
        props.onTimerEnd && props.onTimerEnd();
      }
    };

    let intervalId = setInterval(setTimer, 1000);

    setTimer();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [props.utcHour]);

  return (
    <div className={css.block}>
      <div className={css.item}>
        <div className={css.value}>{timerValues.hours}</div>
        <div className={css.label}>часов</div>
      </div>
      <div className={css.item}>
        <div className={css.value}>{timerValues.minutes}</div>
        <div className={css.label}>минут</div>
      </div>
      <div className={css.item}>
        <div className={css.value}>{timerValues.seconds}</div>
        <div className={css.label}>секунд</div>
      </div>
    </div>
  );
};
